import React from 'react';
import { getEditorPreloader } from '@confluence-classic/confluence-fabric-editor/src/lib/index.ts';

import type { RouteMatch } from '@confluence/route/entry-points/Route.ts';
import { LoadablePaint } from '@confluence/loadable';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { START_TOUCH } from '@confluence/navdex/entry-points/NavdexPointType.ts';

import SpaceBase from '../../SpaceBase/index.js';
import type { IEditorPreloader } from '@confluence/edit-button/entry-points/types.ts';

const SpacePages = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpacePages" */ '@confluence/space-pages/entry-points/SpacePages.ts'
			)
		).SpacePages,
});

export const SpacePagesRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS({ params: { spaceKey } }: RouteMatch): {
		Screen: {
			screenEvent: {
				name: string;
				attributes: {
					navigationLayer: string;
					navdexPointType: string;
				};
			};
			pageState: {
				spaceKey: string;
			};
		};
		MainLayout: {
			navView: string;
			spaceKey: string;
			editorPreloader: () => Promise<() => (config: IEditorPreloader) => JSX.Element>;
			disableMinWidth: boolean;
		};
	};
} = (): React.JSX.Element => {
	return (
		<SpaceBase>
			<SpacePages />
		</SpaceBase>
	);
};

SpacePagesRoute.NAVIGATION_PARAMS = ({
	params: { spaceKey },
}: RouteMatch): {
	Screen: {
		screenEvent: {
			name: string;
			attributes: {
				navigationLayer: string;
				navdexPointType: string;
			};
		};
		pageState: {
			spaceKey: string;
		};
	};
	MainLayout: {
		navView: string;
		spaceKey: string;
		editorPreloader: () => Promise<() => (config: IEditorPreloader) => JSX.Element>;
		disableMinWidth: boolean;
	};
} => ({
	Screen: {
		screenEvent: {
			name: 'spacePagesScreen',
			attributes: {
				navigationLayer: 'container',
				navdexPointType: START_TOUCH,
			},
		},
		pageState: { spaceKey },
	},
	MainLayout: {
		navView: CONTAINER_HOME_ID,
		spaceKey,
		editorPreloader: getEditorPreloader,
		disableMinWidth: true,
	},
});
